module.exports = __webpack_public_path__ + "static/media/location-unknown.c4d580e8.png";